<div class="w-full px-2 lg:px-4 bg-white rounded-lg py-2 mt-2">
  <div class="sm:flex md:block xl:flex items-center justify-between gap-2">
    <p
      class="text-0d5bab font-bold text-[13px] sm:text-sm lg:text-base xl:text-lg capitalize mb-2 sm:mb-0 md:mb-2 xl:mb-0">
      Accounts Panel</p>
    <div class="flex flex-wrap items-center justify-start gap-2 md:gap-1 lg:gap-2">
      <!-- all firms -->
      <!-- <select class="w-22 bg-white border border-acb1c6 rounded-md ps-1 2xl:ps-2 pe-7 py-0.75 text-[13px] text-383838"
        [(ngModel)]="selectedFirmId" (change)="onFirmSelect($event)">
        <option value="">All Firms</option>
        <option *ngFor="let firm of firms" [value]="firm.id">
          {{ firm.name }}
        </option>
      </select> -->
      <!-- desktop Tabs -->
      <div class="hidden md:flex">
        <a [routerLink]="'/accounts'" routerLinkActive="bg-metal-settled-blue !text-white border-metal-settled-blue"
          [routerLinkActiveOptions]="{ exact: true }"
          class="cursor-pointer w-max text-898989 border-d9d9d9 px-1.5 lg:px-4 py-1 text-center text-[13px] lg:text-[15px] border rounded-l-md font-medium transition-all duration-300">
          Accounts
        </a>
        <a [routerLink]="'/accounts/add-new-account'" routerLinkActive="bg-metal-settled-blue !text-white border-metal-settled-blue"
          [routerLinkActiveOptions]="{ exact: true }"
          class="cursor-pointer w-max text-898989 border-d9d9d9 px-1.5 lg:px-4 py-1 text-center text-[13px] lg:text-[15px] border font-medium transition-all duration-300">
          Add New Account
        </a>
        <a [routerLink]="'/accounts/update-all-accounts'" routerLinkActive="bg-metal-settled-blue !text-white border-metal-settled-blue"
          [routerLinkActiveOptions]="{ exact: true }"
          class="cursor-pointer w-max text-898989 border-d9d9d9 px-1.5 lg:px-4 py-1 text-center text-[13px] lg:text-[15px] border font-medium transition-all duration-300">
          Update All Accounts
        </a>
        <a [routerLink]="'/accounts/user-accounts'" routerLinkActive="bg-metal-settled-blue !text-white border-metal-settled-blue"
          [routerLinkActiveOptions]="{ exact: true }"
          class="cursor-pointer w-max text-898989 border-d9d9d9 px-1.5 lg:px-4 py-1 text-center text-[13px] lg:text-[15px] border font-medium transition-all duration-300">
          User Accounts
        </a>
        <a [routerLink]="'/accounts/account-balance'" routerLinkActive="bg-metal-settled-blue !text-white border-metal-settled-blue"
          [routerLinkActiveOptions]="{ exact: true }"
          class="cursor-pointer w-max text-898989 border-d9d9d9 px-1.5 lg:px-4 py-1 text-center text-[13px] lg:text-[15px] border rounded-r-md font-medium transition-all duration-300">
          Account Balance
        </a>
      </div>

      <!-- Mobile Tabs -->
      <div class="block md:hidden">
        <select
          class="w-20 sm:w-auto bg-white border border-d9d9d9 rounded-md px-2 pe-7 py-0.75 text-[13px] text-383838"
          (change)="onTabChange($event)">
          <option value="/accounts">Accounts</option>
          <option value="/accounts/add-new-account">Add New Account</option>
          <option value="/accounts/update-all-accounts">Update All Accounts</option>
          <option value="/accounts/user-accounts">User Accounts</option>
          <option value="/accounts/account-balance">Account Balance</option>
        </select>
      </div>

      <!-- Export Button -->
      <button
        class="cursor-pointer capitalize rounded-md border bg-white text-898989 text-[13px] lg:text-[15px] font-medium px-2 lg:px-4 py-1 text-center">Export</button>
      <!-- Print Button -->
      <button
        class="cursor-pointer capitalize rounded-md border border-0d5bab bg-e7eefb text-0d5bab text-[13px] lg:text-[15px] font-medium px-2 lg:px-4 py-1 text-center">Print</button>
    </div>
  </div>

  <div class="w-full mt-4 space-y-2">
    <router-outlet></router-outlet>
  </div>
</div>
